import { createFileRoute } from '@tanstack/react-router'

import { AccountPreferencesPage } from '#features/settings/account/account-preferences-page'

export const Route = createFileRoute(
  '/_app/$workspace/settings/account/preferences',
)({
  head: () => ({
    meta: [
      {
        title: 'Preferences',
      },
    ],
  }),
  component: () => <AccountPreferencesPage />,
})
